import { render } from "./lobbi-section.vue?vue&type=template&id=378d85c8"
import script from "./lobbi-section.vue?vue&type=script&lang=js"
export * from "./lobbi-section.vue?vue&type=script&lang=js"

import "./lobbi-section.vue?vue&type=style&index=0&id=378d85c8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__